/* This file is automatically generated for @graphcommerce/graphql/config */

export * from './config'
import { plugin as hygraphGraphqlConfig } from '@graphcommerce/graphcms-ui/plugins/hygraphGraphqlConfig'
import { plugin as magentoGraphqlConfig } from '@graphcommerce/magento-graphql/plugins/magentoGraphqlConfig'
import { plugin as magentoStoreGraphqlConfig } from '@graphcommerce/magento-store/plugins/magentoStoreGraphqlConfig'
import { ComponentProps } from 'react'
import { graphqlConfig as graphqlConfigBase } from './config'

/**
 * Interceptor for `graphqlConfig()` with these plugins:
 * 
 * - `@graphcommerce/graphcms-ui/plugins/hygraphGraphqlConfig`
 * - `@graphcommerce/magento-graphql/plugins/magentoGraphqlConfig`
 * - `@graphcommerce/magento-store/plugins/magentoStoreGraphqlConfig`
 */
const magentoStoreGraphqlConfigInterceptor: typeof graphqlConfigBase = (...args) => {
  return magentoStoreGraphqlConfig(graphqlConfigBase, ...args)
}
const magentoGraphqlConfigInterceptor: typeof graphqlConfigBase = (...args) => {
  return magentoGraphqlConfig(magentoStoreGraphqlConfigInterceptor, ...args)
}
const hygraphGraphqlConfigInterceptor: typeof graphqlConfigBase = (...args) => {
  return hygraphGraphqlConfig(magentoGraphqlConfigInterceptor, ...args)
}
export const graphqlConfig = hygraphGraphqlConfigInterceptor
